import { render, staticRenderFns } from "./SearchSorting.vue?vue&type=template&id=89a7459e"
import script from "./SearchSorting.vue?vue&type=script&lang=js"
export * from "./SearchSorting.vue?vue&type=script&lang=js"
import style0 from "./SearchSorting.vue?vue&type=style&index=0&id=89a7459e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports